import React, {useState} from 'react';
import { createGlobalStyle } from 'styled-components';
import { approveSomeAddress } from '../data'
import { removeExponents } from '../utils'


const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    
  }
  .box-login p{
    color: #a2a2a2 !important;
  }
  .box-login{
    border-radius: 3px;
    padding: 40px 50px;
  }
`;

const ApproveForm= () => {
  const [walletAddress, setWalletAddress] = useState('');
  const [amount, setAmount] = useState(0);

  const handleAddressInputChanged = (event) =>{
    setWalletAddress(event.target.value);
  }
  const handleAmountInputChanged = (event) =>{
    setAmount(event.target.value);
  }
  
  
  const handleButtonAction = async() => {
    if(walletAddress===""||amount===""){
      alert("Wallet Address or Amount can't be empty");
    }else if(parseFloat(amount)<0 || parseFloat(amount)===0){
      alert("Amount can't be negative Or zero");
    }else{
      let convertedAmount = (amount*10**18).toString();
      if(convertedAmount.includes('e') || convertedAmount.includes('E')){
        convertedAmount = removeExponents(convertedAmount);
      }
      await approveSomeAddress(walletAddress,convertedAmount);
    }
  }

  return(
<div>
<GlobalStyles/>
      <div className='container'>
        <div className='row align-items-center px-0'>
          <div className="col-lg-10 offset-lg-10 m-auto px-0">
            <div className="box-login">
              <h3 className="mb10">Approve Someone Spend Your Token</h3>
              <div  name="setBeneficiaryForm" id='setBeneficiaryForm' className="form-border" action='#'>

                  <div className="field-set">
                      <input type='text' name='walletAddress' id='walletAddress' onChange={handleAddressInputChanged.bind(this)} className="form-control" placeholder="Spender Wallet Address"/>
                  </div>
                
                 <div className="field-set">
                      <input type='number' name='amount' id='amount' min="0" step="0.0000001" max="1000000000" onChange={handleAmountInputChanged.bind(this)} className="form-control" placeholder="Amount to Approve"/>
                  </div>
                
                <div className="field-set">
                  <input type='submit' id='sendBtn' value='Set Beneficiary' onClick={async()=> await handleButtonAction()} className="btn btn-main btn-fullwidth color-2"/>
                </div>
                
                <div className="clearfix"></div>  
                <div className="spacer-half"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
</div>
  )

}
export default ApproveForm;